module.exports = __webpack_public_path__ + "img/20161119_104809-1 (2).0bb1ac89.jpg";